/**
* Created by matthiasprinz on 12.08.17.
*/
/**
* Created by matthiasprinz on 12.08.17.
*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import Divider from 'material-ui/Divider';
import { style } from './formStyle'
import {
  changedValueAddedTax,
  changedJudicialMattersIsActive,
  changedJudicialVV1000,
  changedJudicialVV1008,
  changedJudicialVV3100,
  changedJudicialVV3104,
  changedJudicialVV7001_7002,
  changedJudicialVV7000_7003,
  changedJudicialANRECHNUNG,
} from '../../actions/index.js';


class JudicalMattersForm extends Component {
  constructor(props) {
    super(props);
    //this.state = {value: ''};
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleToggle = this.handleToggle.bind(this)

  }
  getJudicialMatters() {
    if (!this.props.feeCalculation.judicialIsActive) return ""
    return this.props.feeCalculation.feeMattersJudicial.map((matter) =>
    (
      <TextField type="number" label="gerichtlich" name={ matter.ziff}
        value={matter.isSetted}
        onChange={this.handleChange}
        floatingLabelFixed = {true}
        floatingLabelText={matter.kurzbezeichnung + ' ' + matter.ziff}
        floatingLabelStyle={style.inputFloatingLabelStyleForMatters}
        floatingLabelFocusStyle={style.inputfloatingLabelFocusStyle}
        underlineStyle={style.inputUnderlineStyle}
        style={style.matterInput}
        inputStyle={style.inputInputStyle}
        />
    )
  )
}
handleChange(event) {
  const name = event.target.name;
  //        console.log(event.target.name)
  switch (name) {
      case 'VV1000':
        console.log(event.target.value);
        this.props.changedJudicialVV1000(event.target.value);
        break;
    case 'VV1008':
        console.log(event.target.value);
        this.props.changedJudicialVV1008(event.target.value);
        break;
      case 'VV3100':
        console.log(event.target.value);
        this.props.changedJudicialVV3100(event.target.value);
        break;
      case 'VV3104':
        console.log(event.target.value);
        this.props.changedJudicialVV3104(event.target.value);
        break;
        case 'VV7001,7002':
        console.log(event.target.value);
        this.props.changedJudicialVV7001_7002(event.target.value);
        break;
      case 'VV7000,7003ff.':
        console.log(event.target.value);
        this.props.changedJudicialVV7000_7003(event.target.value);
        break;
      case 'Anrechnung':
        console.log(event.target.value);
        this.props.changedJudicialANRECHNUNG(event.target.value);
        break;
      default:
        console.log('Case nicht gefunden ' + event.target.value);
  }
}
handleSubmit(event) {
  alert('A name was submitted: ' + this.state.value);
  event.preventDefault();
}

handleToggle(event,isInputChecked){
  console.log(event)
  this.props.changedJudicialMattersIsActive(isInputChecked)
}

styles = {

  toggle: {
    marginBottom: 16,
    width: '250px',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontSize: '24px',
    fontWeight: 'bold'
  }
}

toggle ()  {
  return(

    <Toggle
      label="gerichtlich"
      labelPosition="right"
      defaultToggled={this.props.feeCalculation.judicialIsActive}
      style={this.styles}
      name="judicialMattersIsActive"
      onToggle={this.handleToggle}
      />

  )}


  render(){
    return (
      <div>
        <Divider/>
        {this.toggle()}
        {this.getJudicialMatters()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    feeTable: state.feeTable,
    feeMatters: state.feeMatters,
    feeCalculation: state.feeCalculation

  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    changedValueAddedTax: changedValueAddedTax,
    changedJudicialVV1000: changedJudicialVV1000,
    changedJudicialVV1008: changedJudicialVV1008,
    changedJudicialVV3100: changedJudicialVV3100,
    changedJudicialVV3104: changedJudicialVV3104,
    changedJudicialVV7001_7002: changedJudicialVV7001_7002,
    changedJudicialVV7000_7003: changedJudicialVV7000_7003,
    changedJudicialMattersIsActive : changedJudicialMattersIsActive,
    changedJudicialANRECHNUNG : changedJudicialANRECHNUNG,
  }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(JudicalMattersForm);



// WEBPACK FOOTER //
// ./src/containers/form/judicialMatters.jsx